import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { NavigationService } from "../../services/navigation/navigation.service";
import { UserService } from "../../services/user/user.service";

import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private userService: UserService, private navigationService: NavigationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.get()
      .map(user => true)
      .catch(err => {
        if (err && err.status === 401) {
          // TODO: avoid dead loop
          this.navigationService.goToLoginPage();
        } else {
          // TODO: show message to user
        }
        return Observable.of(false);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/guards/auth/auth.guard.ts